





















import { Widgets } from '@/js/vuex/modules/dashboard/types';
import { mapState } from 'vuex';
export default {
  name: 'MenuItem',
  props: {
    label: {
      type: String,
      required: true
    },
    associatedKPI: {
      type: String
    },
    nomeOriginal: {
      type: String,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    agrupamentosPossiveis: {
      type: Array
    },
    agruparPor: {
      type: String,
      default: 'Dia'
    },
    reference: {
      type: String,
      required: true
    }
  },
  methods: {
    handleDrag(tipo: Widgets) {
      this.$root.$emit('dragDashboardEditor', tipo, this.propsWidget);
    },
    handleDragEnd(tipo: Widgets) {
      this.$root.$emit('dragEndDashboardEditor', tipo, this.propsWidget);
    },
    handleIcon(tipo:string) {
      if (this.nomeOriginal === 'Painel de Vendas') tipo = 'panel';
      const strategy = {
        CHART: 'fas fa-chart-line',
        CARD: 'fas fa-columns',
        TABLE: 'fa fa-trophy',
        panel: 'fa fa-table'
      };
      return strategy[tipo];
    }
  },
  computed: {
    ...mapState({
      // @ts-ignore
      siderCollapsed: state => state.siderCollapsed
    }),
    propsWidget() {
      const widgetProps = Object.assign({}, { ...this.$props });

      if (widgetProps.agrupamentosPossiveis) {
        const [agrupamento] = widgetProps.agrupamentosPossiveis;
        widgetProps.agruparPor = agrupamento;
      }
      return widgetProps;
    }
  }
};
